var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeeingMoneyLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Clipping_Mask",
    "data-name": "Clipping Mask",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 182.21 171.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 23.34,
    y: 20.54,
    width: 134.97,
    height: 130.06
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 29.73,
    y1: 87.32,
    x2: 154.67,
    y2: 87.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#95d1fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#74a4c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3f5974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#1d2b3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11192b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 51.09,
    y1: 86.69,
    x2: 133.62,
    y2: 86.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4ffdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d2fedc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#afe6bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#92d3a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#7bc496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#6bba89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#61b382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5fb280"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M154.67,38.38v97.88h-16.08V63.28l-40.64,72.99h-11.31L45.81,63.14v73.13h-16.08V38.38h17.32l45.24,80.91,45.24-80.91h17.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.38,122.19c-2.83,4.1-6.98,7.52-12.46,10.25-5.48,2.74-12.05,4.29-19.7,4.67v11.46h-9.54v-11.46c-10.72-.76-19.44-3.51-26.15-8.27-6.71-4.76-10.13-10.82-10.25-18.18h17.14c.47,3.96,2.32,7.4,5.57,10.33,3.24,2.92,7.8,4.76,13.69,5.52v-35.36c-7.89-1.6-14.25-3.25-19.08-4.95-4.83-1.7-8.96-4.34-12.37-7.92-3.42-3.58-5.12-8.39-5.12-14.43,0-7.64,3.33-13.96,9.98-18.95,6.65-5,15.52-7.78,26.59-8.35v-11.74h9.54v11.74c10.01.66,18.08,3.23,24.21,7.71,6.12,4.48,9.66,10.3,10.6,17.47h-17.14c-.59-3.3-2.42-6.29-5.48-8.98-3.07-2.69-7.13-4.46-12.19-5.3v34.51c7.78,1.6,14.11,3.23,19,4.88,4.89,1.65,9.01,4.27,12.37,7.85,3.36,3.58,5.04,8.44,5.04,14.57,0,4.53-1.41,8.84-4.24,12.94ZM72.65,73.74c3.42,2.45,8.42,4.48,15.02,6.08v-32.68c-6.13.47-11.02,2.05-14.67,4.74-3.65,2.69-5.48,6.44-5.48,11.25s1.71,8.16,5.12,10.61ZM112.15,121.13c3.59-3.11,5.39-6.84,5.39-11.17,0-4.62-1.77-8.18-5.3-10.68-3.53-2.5-8.54-4.5-15.02-6.01v33.38c6.36-.57,11.34-2.4,14.93-5.52Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeingMoneyLogo);
export default __webpack_public_path__ + "static/media/SeeingMoneyLogo.aa5c2f403e36275b63a4d5665c1e5e90.svg";
export { ForwardRef as ReactComponent };